// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fqPrL","account":"styles_account__1mdnB","userText":"styles_userText__26gt3","logout":"styles_logout__2J63E"};